export default {
  title: '商戶管理',
  companyInfo: '企業信息',
  emailConfig: '郵箱配置',
  smsConfig: '短信配置',
  i18nManagement: '多語言管理',
  paymentAuthConfig: '支付與授權配置',
  systemSettings: '系統設置',
  roleManagement: '角色管理',
  accountManagement: '賬號管理',
  operationLog: '操作日誌',
};
